import { OnInit, EventEmitter } from '@angular/core';
import { Menu } from '../../shared/menu/menu.model';
var FullMenuHeaderComponent = /** @class */ (function () {
    function FullMenuHeaderComponent() {
        this.newMenu = new EventEmitter();
    }
    FullMenuHeaderComponent.prototype.ngOnInit = function () {
    };
    FullMenuHeaderComponent.prototype.ngOnChanges = function () {
        if (this.menu)
            this.categoryMenu = this.menu;
    };
    FullMenuHeaderComponent.prototype.onMenuChange = function (event) {
        this.newMenu.emit(event);
    };
    Object.defineProperty(FullMenuHeaderComponent.prototype, "menuDescription", {
        get: function () {
            var fixedText = "Aqui você consegue visualizar todas as opções disponíveis para ";
            if (!this.description)
                return this.description;
            return fixedText + this.description;
        },
        enumerable: true,
        configurable: true
    });
    return FullMenuHeaderComponent;
}());
export { FullMenuHeaderComponent };
